import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Button, Col, Row, Divider } from '_zari/core'

import { ModalidadCalculosDeDepreciacionConstant } from 'constants/index'

import * as CompaniaCrud from 'services/compania.service'
import * as AsientosContablesCrud from 'services/asientosContables.service'

import * as FormGroups from './formGroups'
import * as Partials from './formGroups/partials'

import validationSchema from './validacion'
import getValoresIniciales from './valoresIniciales'

const CompaniaFichaPage = ({ dataCompania }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return getValoresIniciales(dataCompania)
  }, [dataCompania])

  const [validandoSire, setValidandoSire] = React.useState(false)

  const submitHandler = async data => {
    await CompaniaCrud.actualizarCompania(data)
      .then(() => {
        __zariContext.snack('success', 'Datos actualizados.')
        window.location.reload()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  const validarSireHandler = async () => {
    setValidandoSire(true)
    try {
      const { data } = await AsientosContablesCrud.sireValidarCredenciales()
      __zariContext.snack(data.valido ? 'success' : 'error', data.mensaje)
    } catch (e) {
      __zariContext.snack('error', e?.data?.error || 'No se pudo validar las credenciales SIRE.')
    } finally {
      setValidandoSire(false)
    }
  }

  return (
    <>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={validationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setValues, setFieldValue, handleChange }) => (
          <Form>
            <Divider title='Datos' />
            <Row>
              <Col md={4}>
                {/* <Form.Group>
                  <Form.Label text='RUC' md={4} alignRightAt='md' />
                  <Col md={8}>
                    <Form.InputText id='readonly-ruc' name='readonly-ruc' defaultValue={values.ruc} disabled />
                  </Col>
                </Form.Group> */}
                <FormGroups.RucFormGroup
                  iError={errors.ruc}
                  iTouched={touched.ruc}
                  fIsSubmitting={isSubmitting}
                  setFieldValue={setFieldValue}
                  vRuc={values.ruc}
                />
              </Col>
              <Col md={8}>
                <Form.Group>
                  <Form.Label text='RAZON SOCIAL' md={2} alignRightAt='md' />
                  <Col md={10}>
                    <Form.InputText
                      id='readonly-razonSocial'
                      name='readonly-razonSocial'
                      defaultValue={values.razonSocial}
                      disabled
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Divider title='Cuentas contables' />
            <Row>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableGananciaTC'
                  iLabel='GANANCIA T/C'
                  iName='cuentaContableGananciaTC'
                  iError={errors.cuentaContableGananciaTC}
                  iTouched={touched.cuentaContableGananciaTC}
                  iValue={values.cuentaContableGananciaTC}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContablePerdidaTC'
                  iLabel='PERDIDA T/C'
                  iName='cuentaContablePerdidaTC'
                  iError={errors.cuentaContablePerdidaTC}
                  iTouched={touched.cuentaContablePerdidaTC}
                  iValue={values.cuentaContablePerdidaTC}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableRetencionIGV'
                  iLabel='RETENCION IGV'
                  iName='cuentaContableRetencionIGV'
                  iError={errors.cuentaContableRetencionIGV}
                  iTouched={touched.cuentaContableRetencionIGV}
                  iValue={values.cuentaContableRetencionIGV}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableRetencionRH'
                  iLabel='RETENCION RH'
                  iName='cuentaContableRetencionRH'
                  iError={errors.cuentaContableRetencionRH}
                  iTouched={touched.cuentaContableRetencionRH}
                  iValue={values.cuentaContableRetencionRH}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableICBPER'
                  iLabel='ICBPER'
                  iName='cuentaContableICBPER'
                  iError={errors.cuentaContableICBPER}
                  iTouched={touched.cuentaContableICBPER}
                  iValue={values.cuentaContableICBPER}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableResultadoGananciaEjercicio'
                  iLabel='GANAN. EJERC. (89)'
                  iName='cuentaContableResultadoGananciaEjercicio'
                  iError={errors.cuentaContableResultadoGananciaEjercicio}
                  iTouched={touched.cuentaContableResultadoGananciaEjercicio}
                  iValue={values.cuentaContableResultadoGananciaEjercicio}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableResultadoPerdidaEjercicio'
                  iLabel='PERD. EJERC. (89)'
                  iName='cuentaContableResultadoPerdidaEjercicio'
                  iError={errors.cuentaContableResultadoPerdidaEjercicio}
                  iTouched={touched.cuentaContableResultadoPerdidaEjercicio}
                  iValue={values.cuentaContableResultadoPerdidaEjercicio}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableResultadoEjercicio'
                  iLabel='RESULTADO EJERC.'
                  iName='cuentaContableResultadoEjercicio'
                  iError={errors.cuentaContableResultadoEjercicio}
                  iTouched={touched.cuentaContableResultadoEjercicio}
                  iValue={values.cuentaContableResultadoEjercicio}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContablePercepcionIGV'
                  iLabel='PERCEPCION IGV'
                  iName='cuentaContablePercepcionIGV'
                  iError={errors.cuentaContablePercepcionIGV}
                  iTouched={touched.cuentaContablePercepcionIGV}
                  iValue={values.cuentaContablePercepcionIGV}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <FormGroups.DepartamentoFormGroup
                  values={values}
                  setValues={setValues}
                  handleChange={handleChange}
                  iError={errors._idDepartamento}
                  iTouched={touched._idDepartamento}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.ProvinciaFormGroup
                  values={values}
                  setValues={setValues}
                  handleChange={handleChange}
                  idDepartamento={values._idDepartamento}
                  iError={errors._idProvincia}
                  iTouched={touched._idProvincia}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.DistritoFormGroup
                  idProvincia={values._idProvincia}
                  iError={errors._idDistrito}
                  iTouched={touched._idDistrito}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
            </Row>
            <Divider title='Cuentas contables - tributos' />
            <Row>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableIGVVenta'
                  iLabel='IGV VENTA'
                  iName='cuentaContableIGVVenta'
                  iError={errors.cuentaContableIGVVenta}
                  iTouched={touched.cuentaContableIGVVenta}
                  iValue={values.cuentaContableIGVVenta}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableIGVCompra1'
                  iLabel='IGV COMPRA CUENTA PROPIA'
                  iName='cuentaContableIGVCompra1'
                  iError={errors.cuentaContableIGVCompra1}
                  iTouched={touched.cuentaContableIGVCompra1}
                  iValue={values.cuentaContableIGVCompra1}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableIGVCompra2'
                  iLabel='IGV COMPRA 2'
                  iName='cuentaContableIGVCompra2'
                  iError={errors.cuentaContableIGVCompra2}
                  iTouched={touched.cuentaContableIGVCompra2}
                  iValue={values.cuentaContableIGVCompra2}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableIGVCompra4016'
                  iLabel='IGV A OP NO GRAV'
                  iName='cuentaContableIGVCompra4016'
                  iError={errors.cuentaContableIGVCompra4016}
                  iTouched={touched.cuentaContableIGVCompra4016}
                  iValue={values.cuentaContableIGVCompra4016}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableIGVCompra4017'
                  iLabel='IGV A OP COMUN'
                  iName='cuentaContableIGVCompra4017'
                  iError={errors.cuentaContableIGVCompra4017}
                  iTouched={touched.cuentaContableIGVCompra4017}
                  iValue={values.cuentaContableIGVCompra4017}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={6} md={4}>
                <Partials.CuentaContablePickerFormGroup
                  iDescripcionName='descripcionCuentaContableISC'
                  iLabel='ISC'
                  iName='cuentaContableISC'
                  iError={errors.cuentaContableISC}
                  iTouched={touched.cuentaContableISC}
                  iValue={values.cuentaContableISC}
                  fIsSubmitting={isSubmitting}
                  values={values}
                  setValues={setValues}
                />
              </Col>
            </Row>
            <Divider title='Cuentas corrientes' />
            <Row>
              <Col sm={4}>
                <FormGroups.CuentaCorrienteDetraccionFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.cuentaCorrienteDetraccion}
                  iTouched={touched.cuentaCorrienteDetraccion}
                />
              </Col>
            </Row>
            <Divider title='Credenciales SIRE' />
            <Row>
              <Col sm={4}>
                <FormGroups.IdCLienteSIREFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.idCLienteSIRE}
                  iTouched={touched.idCLienteSIRE}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.ClaveClienteFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.claveCLienteSIRE}
                  iTouched={touched.claveCLienteSIRE}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <FormGroups.UsuarioSOLFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.usuarioSOL}
                  iTouched={touched.usuarioSOL}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.ClaveSOLFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.claveSOL}
                  iTouched={touched.claveSOL}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <Button block variant='outline-primary' disabled={validandoSire} onClick={validarSireHandler}>
                  {validandoSire ? 'Validando...' : 'Validar credenciales SIRE'}
                </Button>
              </Col>
              <Col sm={8}>
                <small className='text-muted'>
                  Prueba la conexión con SUNAT usando las credenciales guardadas. Si cambiaste algún dato, guarda primero
                  con "Guardar Cambios" antes de validar.
                </small>
              </Col>
            </Row>
            <Divider title='Otros' />
            <Row>
              <Col sm={4}>
                <FormGroups.DefectoAfectacionComprasFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.defectoAfectacionCompras}
                  iTouched={touched.defectoAfectacionCompras}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.DefectoAfectacionVentasFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.defectoAfectacionVentas}
                  iTouched={touched.defectoAfectacionVentas}
                />
              </Col>
              <Col md={2}>
                <FormGroups.Flag1500UitFormGroup fIsSubmitting={isSubmitting} iValue={values.flag1500Uit} />
              </Col>
            </Row>
            <Row>
              <Col sm={4}>
                <FormGroups.CalculoDeDepreciacionFormGroup
                  iValue={values.calculoDeDepreciacion}
                  fIsSubmitting={isSubmitting}
                />
              </Col>
              <Col sm={4}>
                <FormGroups.ModalidadDeCalculoDeDepreciacionFormGroup
                  iValue={values.modalidadCalculoDeDepreciacion}
                  fIsSubmitting={isSubmitting}
                />
                {values.modalidadCalculoDeDepreciacion === ModalidadCalculosDeDepreciacionConstant._6A8_DIST ||
                  values.modalidadCalculoDeDepreciacion === ModalidadCalculosDeDepreciacionConstant.CLASE9 ||
                  values.modalidadCalculoDeDepreciacion === ModalidadCalculosDeDepreciacionConstant._CLASE9_CC ? (
                  <FormGroups.CuentaContableClase7FormGroup
                    setFieldValue={setFieldValue}
                    iError={errors.cuentaContableClase7}
                    iTouched
                    iValue={values.cuentaContableClase7Info}
                  />
                ) : null}
              </Col>
              <Col md={2}>
                <FormGroups.FlagPaseConsumosFormGroup fIsSubmitting={isSubmitting} iValue={values.flagPaseConsumos} />
                <FormGroups.FLagAltoBajoFormGroup fIsSubmitting={isSubmitting} iValue={values.flagAltoBajo} />
              </Col>
            </Row>
            <Row className='mt-5'>
              <Col md={4}></Col>
              <Col md={4}>
                <Button block onClick={handleSubmit}>
                  Guardar Cambios
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  )
}

export default CompaniaFichaPage
